import React, { Component } from 'react';
import { Platform, StyleSheet, View, Text, Dimensions } from 'react-native'
import { JDText, JDDevice, JDImage } from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import constants from '../../utils/constants'
import locationImg from './assets/location.png';
import bus from './assets/bus3.png'
import subway from './assets/subway3.png'
import hospital from './assets/hospital3.png'
import school from './assets/school3.png'
import shop from './assets/shooping3.png'
import bank from './assets/bank3.png'
import LoadingGif from './assets/loading.gif'
import { TMap } from '../../utils/ut.web'
import { getPointList } from '../../utils/api'

let map = null;
let marker = null;
let textOverlayClass = null;
let districtOverlay = null;
let searchService = null;

let getMapNavItemWidth = 0
	// 计算元素宽度
	const screenWidth = Dimensions.get('window').width; 
	// tabItemWith = ( 屏幕宽度 - 左右边距 - tab 间隔距离 ) / 6
	getMapNavItemWidth = (screenWidth - JDDevice.getRpx(108) - JDDevice.getRpx(80)) / 6 
	// console.log('getMapNavItemWidth 执行了',screenWidth,getMapNavItemWidth);


const HTML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    "`": '&#x60;',
    "=": '&#x3D;'
};

const escapeHtml = (text) => {
    if (text === null || text === undefined) {
        return '';
    }
    return String(text).replace(/[&<>"'`=]/g, (match) => HTML_ESCAPE_MAP[match]);
};

export default class MapWeb extends Component {
	static propTypes = {
		addressLat: PropTypes.number,	// 纬度
		addressLon: PropTypes.number,	// 经度
		latSpace: PropTypes.number, // 维度偏移距离（为0时，定位图标垂直居中展示）
		lonSpace: PropTypes.number, // 经度偏移距离（为0时，定位图标水平居中展示）
		plotName: PropTypes.string,	// 点位名称
		plotAddress: PropTypes.string,	// 地址
		mapStyle: PropTypes.object,	// 地图样式
		zoom: PropTypes.number,	// 缩放级别
		hasPoint: PropTypes.bool, // 是否有周边列表
		onMapPress: PropTypes.func,	// 地图点击事件
		pageShowMap: PropTypes.bool, // 是否可以请求地图周边服务（曝光）
	}
	static defaultProps = {
		latSpace: 0,
		lonSpace: 0,
		mapStyle: {},
		zoom: 14,
		hasPoint: false
	}

	state = {
		tabListInfo: [
			{
				icon: bus,
				name: '公交',
				range: 3000,  // 范围
				pointList:null
			},
			{
				icon: subway,
				name: '地铁',
				range: 3000,
				pointList:null
			},
			{
				icon: hospital,
				name: '医院',
				range: 3000,
				pointList:null
			},
			{
				icon: school,
				name: '学校',
				range: 3000,
				pointList:null
			},
			{
				icon: shop,
				name: '商场',
				range: 3000,
				pointList:null
			},
			{
				icon: bank,
				name: '银行',
				range: 3000,
				pointList:null
			},
		],
		isPoiLoading:false, // 是否请求点位列表
		selectTab: 0, // 选中tab
		pointList: [], // 点位列表
		isLoadPoint: false
	}
	// tab切换
	tabClick = (item, index) => {
		this.setState({ selectTab: index })
		const { tabListInfo } = this.state
    if(!!tabListInfo[index].pointList) return	// 已经请求过了
		this.getServicePoint({ index, searchname: item })
	}
	// 初始化地图
	initMap = () => {
		this.destroyMap() // 销毁上一个
		let { addressLat, addressLon, latSpace, lonSpace, plotName, plotAddress, zoom, onMapPress } = this.props
		if (addressLat || addressLon) {
			TMap(constants.mapKey).then(qq => {
				let latLng = new qq.maps.LatLng(addressLat , addressLon ) // 初始化坐标
				map = new qq.maps.Map(document.getElementById("mapcontainer"), {
					center: latLng,
					zoom,
					zoomControl: false,
					mapTypeControl: false
				});
				marker = new qq.maps.Marker({
					icon: new qq.maps.MarkerImage(locationImg, '', '', '', new qq.maps.Size(32, 31)),
					position: new qq.maps.LatLng(addressLat, addressLon),
					map: map
				})
				if (plotName && plotAddress) {
					textOverlayClass = this.getTextOverlay()
					districtOverlay = new textOverlayClass(new qq.maps.LatLng(addressLat, addressLon), plotName, plotAddress)
					districtOverlay.setMap(map)
				}
				// 添加地图点击事件
				qq.maps.event.addListener(map, "click", () => {
					if (onMapPress && typeof onMapPress === 'function') {
						onMapPress()
					}
				});
			})
		}
	}
	// 销毁地图
	destroyMap = () => {
		const el = document.getElementById("mapcontainer");
		el.innerHTML = "";
		if (this.map) {
			this.map = null;
		}
		if (this.marker) {
			this.marker = null;
		}
		if (this.searchService) {
			this.searchService = null;
		}
	}
	componentDidMount() {
		this.initMap()
	}
	componentWillReceiveProps(nextProps) {
    if(!this.state.isLoadPoint && nextProps.pageShowMap) {
			this.getServicePoint({ index: 0, searchname: '公交' })
	  }
  }
	getServicePoint = (searchItem) => {
		const { tabListInfo } = this.state
		const { index, searchname } = searchItem	// 搜索 项 
		let { addressLat, addressLon } = this.props
		let latLng = new qq.maps.LatLng(addressLat , addressLon ) // 初始化坐标

		if (addressLat || addressLon) {
			this.setState({isPoiLoading:true, isLoadPoint: true})	// 设置为true
			try {
				const str = `${latLng.lat},${latLng.lng},3000,0`
				const pparms = {
					keyword: encodeURI(searchname),
					orderby: '_distance',
					boundary: 'nearby(' + str +')',
					pageSize: 10,
					pageIndex: 1,
				}
				searchService = getPointList(pparms).then((res) => {
					if ( res && res.status === 0) {
						this.setState({isPoiLoading:false})	// 请求完毕
						// 检索成功的回调函数
						const pois = res.data || []
						const pointLists = pois && pois.length > 2 ? pois.slice(0,3) : pois
						// 处理数据
						this.setState({
							tabListInfo: tabListInfo.map((item,i) => i === index ? {...item, pointList:pointLists}: item)
						})
					} else {
						this.setState({
							tabListInfo: tabListInfo.map((item,i) => i === index ? {...item, pointList:null}: item),
							isPoiLoading:false	// 请求完毕
						})
					}
				}).catch(err => {
						this.setState({
							tabListInfo: tabListInfo.map((item,i) => i === index ? {...item, pointList:null}: item),
							isPoiLoading:false	// 请求完毕
						})
				});
			} catch (err){
				console.log(err)
			}
		}
	}
	getTextOverlay = () => { // 定义文字覆盖物样式和内容
		function textOverlay(position, title, address) {
			this.position = position;
			this.title = title;
			this.address = address;
		}
		textOverlay.prototype = new qq.maps.Overlay();
		textOverlay.prototype.construct = function () {
			var textBoxDiv = this.textBoxDiv = document.createElement("div");
			var textBoxStyle = textBoxDiv.style;
			textBoxStyle.position = "relative";
			textBoxStyle.zIndex = 10;
			//将dom添加到覆盖物层
			var panes = this.getPanes();
			//设置panes的层级，overlayMouseTarget可接收点击事件
			panes.overlayMouseTarget.appendChild(textBoxDiv);

			const safeTitle = escapeHtml(this.title);
    		const safeAddress = escapeHtml(this.address);

			var textContanierHtml = "";
			var textHtml = `<span style='display: inline-block;color: #000;font-weight:600;font-size: ${JDDevice.getRpx(28)}px;line-height:  ${JDDevice.getRpx(40)}px;text-align: center;width: 100%;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;' >` + safeTitle + `</span><br><span style='display: inline-block;width: 100%;text-align: center;color: #888;font-size:  ${JDDevice.getRpx(22)}px;line-height: ${JDDevice.getRpx(30)}px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'>` + safeAddress + "</span>";

			textContanierHtml = `<div style='position: absolute;bottom: 0;border-radius: ${JDDevice.getRpx(12)}px;left:-${JDDevice.getRpx(175)}px;width: ${JDDevice.getRpx(350)}px;padding: ${JDDevice.getRpx(12)}px ${JDDevice.getRpx(14)}px;background-color: #fff;overflow: hidden; text-overflow: ellipsis; white-space: nowrap; box-shadow: 0 ${JDDevice.getRpx(6)}px ${JDDevice.getRpx(6)}px 0 rgba(0,0,0,0.12);'>` + textHtml + "</div>";

			var arrowHtml = "<div style='width:0;height:0; border-left: .12rem solid transparent;border-right: .12rem solid transparent;border-top: .16rem solid #fff;margin-left: -.08rem;position: absolute'></div>";

			textContanierHtml += arrowHtml;
			textBoxDiv.innerHTML = textContanierHtml;
		};
		//实现draw接口来绘制和更新自定义的dom元素
		textOverlay.prototype.draw = function () {
			var overlayProjection = this.getProjection();
			//返回覆盖物容器的相对像素坐标
			var pixel = overlayProjection.fromLatLngToDivPixel(this.position);
			var divStyle = this.textBoxDiv.style;
			divStyle.left = pixel.x - 2 + "px";
			divStyle.top = pixel.y - 35 + "px";
		};
		//实现destroy接口来删除自定义的Dom元素，此方法会在setMap(null)后被调用
		textOverlay.prototype.destroy = function () {
			this.textBoxDiv.onclick = null;
			this.textBoxDiv.parentNode.removeChild(this.textBoxDiv);
			this.textBoxDiv = null
		};
		return textOverlay;
	};
	render() {
		let { mapStyle, hasPoint } = this.props;
		const {
			selectTab, 
			isPoiLoading, 
			tabListInfo
		} = this.state
		// 地图 资源列表 Dom
		const renderMapPoint = () => {
			const currentTab = tabListInfo[selectTab].pointList
			const isEmpty = (!currentTab || ( Array.isArray(currentTab) && currentTab.length === 0))
			const mapNavStyle = (index) => selectTab === index ? { ...styles.mapNavItem, ...styles.mapNavItemActive } : styles.mapNavItem
			const currentListDom = isPoiLoading ? 
				<View style={styles.pointListEmpey}>
					<JDImage source={LoadingGif} style={styles.pointListLoadingIcon}/>
					<JDText style={styles.pointListEmpeyMessage} >在来的路上了～～</JDText>
				</View> : isEmpty ? <View style={styles.pointListEmpey}>
					<JDImage source={{ uri: 'https://img12.360buyimg.com/imagetools/jfs/t1/167372/29/4669/3612/6013d61cE2a7cc22c/5636f036d5bda28e.png' }} style={styles.pointListEmpeyIcon} />
					<JDText style={styles.pointListEmpeyMessage} >抱歉，暂未查询到{tabListInfo[selectTab].name}数据</JDText>
				</View> : <View className="point-list-box" style={{ ...styles.mapResourceList }}>
					{
						currentTab.map((item, index) => {
							// 处理距离
							const buildDist = (num) => {
								if (num < 1000) return parseInt(num);
								num = num * 100;
								const result = num / 100000;
								return Math.floor(result * 10) / 10 + "k";
							}
							return <View key={index} style={styles.mapResourceItem}>
								<View style={styles.mapResourceItemFront}>
									<JDImage source={tabListInfo[selectTab].icon} style={styles.mapResourceIcon} />
									<JDText style={{ ...styles.mapResourceName }} numberOfLines={1}>{item.title}</JDText>
								</View>
								<JDText style={{ ...styles.mapResourceDist }} numberOfLines={1}>直线{buildDist(item._distance)}m</JDText>
							</View>
						})
					}
				</View>
			return <div style={{ ...styles.mapResourceBox }}>
				<div className="map-nav-list" style={{ ...styles.mapNavList }} >
					{
						tabListInfo.map((item, index) => <div key={index}
							style={mapNavStyle(index)}
							onClick={() => { this.tabClick(item.name, index) }}> {item.name} </div>)
					}
				</div>
				<div style={{ ...styles.mapResourceList }}>{ currentListDom } </div>
			</div >
		}
		return (
			<View style={{ ...styles.mapAndResourceBox }}>
				{/* 地图 */}
				<div id="mapcontainer" style={{ ...styles.mapCon, ...mapStyle }}></div>
				{/* 资源列表 */}
				{hasPoint && renderMapPoint()}
			</View>
		)
	}
}
const styles = StyleSheet.create({
	mapAndResourceBox: {
		paddingHorizontal: JDDevice.getRpx(30),
		paddingBottom: JDDevice.getRpx(36),
	},
	mapCon: {
		height: JDDevice.getRpx(350),
		width: '100%',
		borderRadius: JDDevice.getRpx(20),
		overflow: 'hidden'
	},
	mapResourceBox: {
		marginTop: JDDevice.getRpx(28),
	},
	// tab 列表
	mapNavList: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: 0,
		padding: 0,
	},
	mapNavItem: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		// width: JDDevice.getRpx(94),
		width: getMapNavItemWidth,
		height: JDDevice.getRpx(57),
		flexShrink: 0,
		borderRadius: JDDevice.getRpx(29),
		fontSize: JDDevice.getRpx(26),
		color: 'rgba(85,85,85,1)',
		backgroundColor: 'rgba(246, 246, 246, 1)',
	},
	mapNavItemActive: {
		color: 'rgba(250,44,25,1)',
		backgroundColor: '#FEE7E4',
		fontWeight: 'bold',
	},
	// 资源列表
	pointListEmpey: {
		width: '100%',
		height: JDDevice.getRpx(228),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
	},
	pointListEmpeyIcon: {
		width: JDDevice.getRpx(154),
		height: JDDevice.getRpx(80)
	},
	pointListLoadingIcon: {
		width: JDDevice.getRpx(60),
		height: JDDevice.getRpx(60)
	},
	pointListEmpeyMessage: {
		color: '#a6aab0',
		fontSize: JDDevice.getRpx(28),
		paddingTop: JDDevice.getRpx(16),
	},
	mapResourceList: {
		margin: 0,
		padding: 0,
		marginTop: JDDevice.getRpx(28),
	},
	mapResourceItem: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		width:'100%',
		height: JDDevice.getRpx(36),
		marginBottom: JDDevice.getRpx(16),
		overflow:'hidden'
	},
	mapResourceItemFront: {
		flexDirection: 'row',
		alignItems: 'center',
		flexShrink:1
	},
	mapResourceIcon: {
		width: JDDevice.getRpx(36),
		height: JDDevice.getRpx(36),
	},
	mapResourceName: {
		position: 'relative',
		paddingLeft: JDDevice.getRpx(12),
		fontSize: JDDevice.getRpx(28),
		overflow: 'hidden',
	},
	mapResourceDist: {
		marginLeft: JDDevice.getRpx(33),
		flexShrink: 0,
		width: JDDevice.getRpx(120),
		color: 'rgba(153,153,153,1)',
		fontSize: JDDevice.getRpx(24),
	}
});
